<template>
	<div class="row">
		<div class="col-sm-12 col-md-12 col-lg-12">
			<div class="login">
				<div class="row row-form">
					<div class="col-sm-12">
						<div id="success" class="email_confirm">{{ $t('you.are.successfully.registered') }}</div>
						<div id="message" class="message"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import http from 'utils/http'

export default {
	name: 'ConfirmEmail',
	metaInfo: {
		title: 'Confirm email'
	},
	props: [
		'token'
	],
	mounted () {
		http.post('auth/confirm-email', {}, {
			params: {
				key: this.token
			}
		})
			.then(() => {
				setTimeout(() => {
					this.$router.push('/attach')
				},1000)
			})
			.catch(error => {
				$('#success').hide()
				$('#message').text('Confirmation error')
				console.log(error)
			})
	}
}
</script>

<style scoped>
	.message {
		height: 50px;
		text-align: center;
		margin-top: 15px;
	}
	.email_confirm {
		text-align: center;
		margin-top: 20px;
	}
</style>
